import { render } from "./TabMenu.vue?vue&type=template&id=6d5262c3"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"

import "./TabMenu.vue?vue&type=style&index=0&id=6d5262c3&lang=css"
script.render = render

export default script